import axios from "axios";
import {tvbizzURL} from "./urlConst";

export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: tvbizzURL,
})
